import { useAppSelector } from "../../Redux/Hooks/hooks.redux";
import { UIMode } from "../../State/UI/UI.state";


export function useUIStatus(): UIMode  {
    return useAppSelector((state)=>(state.appState.appUIState.mode))
}